import styles from './ConvertButton.module.css';

export interface ConvertButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  complete?: boolean;
  label?: string;
  type?: 'button' | 'submit' | 'reset';
}

export function ConvertButton({
  onClick,
  disabled = false,
  loading = false,
  complete = false,
  label = 'Convert to .xmp',
  type = 'button',
}: ConvertButtonProps) {
  const buttonLabel = loading ? 'Converting...' : complete ? 'Converted!' : label;

  return (
    <button
      type={type}
      className={`${styles.btn} ${complete ? styles.complete : styles.primary}`}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
    >
      {loading ? (
        <span className={styles.spinner} aria-hidden="true" />
      ) : complete ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
          <polyline points="1 4 1 10 7 10" />
          <path d="M3.51 15a9 9 0 1 0 .49-3.5" />
        </svg>
      )}
      {buttonLabel}
    </button>
  );
}

export default ConvertButton;
